// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudUpload1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "CloudUpload1/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7 16a4 4 0 0 1-.88-7.903A5 5 0 1 1 15.9 6L16 6a5 5 0 0 1 1 9.9M15 13l-3-3m0 0-3 3m3-3v12"
}));
export default CloudUpload1Icon;